import common from '@page/common/js/common';
import AlertDialog from '@global/helpers/alertDialog';
import $ from 'jquery';
import {
  fireRegisterEvent,
  fireRegisterGTMEventByLINE,
  fireRegisterGTMEventByFB,
} from '@global/gtm/login/register';

import {
  fireLoginEvent,
  fireLoginGTMEventByLINE,
  fireLoginGTMEventByFB,
} from '@global/gtm/login/login';

$('.tab-btn').click(function (e) {
  if (!$(this).hasClass('active')) {
    $(this).addClass('active');
    $(this).siblings('.tab-btn').removeClass('active');
    const target = $(this).data('tablink');
    const siblingsTarget = $(this).siblings('.tab-btn').data('tablink');
    $(target).show();
    $(siblingsTarget).hide();
  }
});

$('.btn-forgot-pwd, .btn-back').on('click', function () {
  $(this).closest('li').toggle();
  $(this).closest('li').siblings('li').fadeToggle();
  $('.tab-login').hide();
});

function register() {
  $('#btnRegister').on('click', function submitRegister(event) {
    const $form = $('#form-register');
    const strUserName = $('#registerUsername').val();
    const strPassword = $('#registerPwd').val();
    const strPasswordAgain = $('#registerPwdAgain').val();
    const regx = /^(?=.*\d)(?=.*[A-Za-z])[^\s]{6,15}$/;
    const $el = $(this);

    $el.addClass('disabled');

    if (strUserName === '') {
      AlertDialog.alert('請輸入會員帳號!', () => {
        $el.removeClass('disabled');
      });
      $('#registerUsername').focus();
    } else if (strPassword === '') {
      AlertDialog.alert('請輸入會員密碼!', () => {
        $el.removeClass('disabled');
      });
      $('#registerPwd').focus();
    } else if (!regx.test(strPassword)) {
      AlertDialog.alert('請設定6碼至15碼英數字!', () => {
        $el.removeClass('disabled');
      });
      $('#registerPwd').focus();
    } else if (strPasswordAgain !== strPassword) {
      AlertDialog.alert('密碼不一致!', () => {
        $el.removeClass('disabled');
      });
      $('#registerPwd').focus();
    } else {
      const account = $form.find('input[name="account"]').val();

      $.ajax({
        url: `${API_URL.ACCOUNT_EXIST}?Account=${account}`,
        type: 'GET',
        dataType: 'json',
        success(res) {
          if (res.Code === 200) {
            if (res.Response) {
              AlertDialog.alert(res.Message, () => {
                $el.removeClass('disabled');
              });
            } else {
              $form.submit();
              fireRegisterEvent();
            }
          } else {
            AlertDialog.alert('系統忙碌中，請稍後再試', () => {
              $el.removeClass('disabled');
            });
          }
        },
        error() {
          AlertDialog.alert('系統忙碌中，請稍後再試', () => {
            $el.removeClass('disabled');
          });
        },
      });
    }

    event.preventDefault();
  });
}

function registerLogin() {
  $('#btnLogin').on('click', function btnLogin(event) {
    const $form = $('#form-login');
    const strUserName = $('#username').val();
    const strPassword = $('#password').val();
    if (strUserName === '') {
      AlertDialog.alert('請輸入會員帳號!');
      $('#username').focus();
    } else if (strPassword === '') {
      AlertDialog.alert('請輸入會員密碼!');
      $('#password').focus();
    } else {
      $form.submit();
      fireLoginEvent();
    }
    event.preventDefault();
  });
}

function registerForgot() {
  $('#btnSend').on('click', function (event) {
    var $form = $('#form-forget-pwd');
    var strErrMsg = '';
    var strUserName = $('#accountForgot').val();
    var mailRegx = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
    var $el = $(this);

    if (strUserName == NaN || strUserName == '') {
      AlertDialog.alert('請輸入會員帳號 !');
      $('#accountForgot').focus();
    } else {
      $el.addClass('disabled');
      $.ajax({
        url: API_URL.FORGET_PS,
        type: 'POST',
        dataType: 'json',
        data: $form.serialize(),
        success: function (res) {
          AlertDialog.alert(res.Message, function () {
            $el.removeClass('disabled');
          });
        },
        error: function (xhr, textStatus, errorThrown) {
          console.log('error');
        },
      });
    }

    event.preventDefault();
  });
}
register();
registerLogin();
registerForgot();

$('.btnFBLogin').on('click', function fbLogin() {
  if (this.parentElement.parentElement.parentElement.id === 'login') {
    fireLoginGTMEventByFB();
  } else {
    fireRegisterGTMEventByFB();
  }
});

$('.btnLINELogin').on('click', function lineLogin() {
  if (this.parentElement.parentElement.parentElement.id === 'login') {
    fireLoginGTMEventByLINE();
  } else {
    fireRegisterGTMEventByLINE();
  }
});
